document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="number"]');
    if (!input) return;

    wrapper.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = Number(button.dataset.quantityButton || 0);
        const min = Number(input.min || 1);
        const next = Math.max(min, Number(input.value || min) + direction);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
});
